import React, { useEffect } from 'react';
import { nanoid } from 'nanoid';

import LinkLogo from './LinkLogo';
import ContactUs from './ContactUs';
import { IMenu } from '../../interfaces/menu.interface';
import { IPageContext } from '../../interfaces/pagecontext.interface';
import LanguageSelector from '../language-selector/LanguageSelector';
import LinkTo from '../link/Link';

interface Props {
  menu: IMenu[];
  pageContext: IPageContext;
  headerDesktopMenuClass: string;
}

const DeviceMenu = ({ menu, pageContext, headerDesktopMenuClass }: Props) => {
  const [devicesOpenedMenu, setDevicesOpenedMenu] = React.useState(false);
  const [devicesOpenedIndex, setDevicesOpenedIndex] = React.useState(-1);
  const setDevicesOpened = (index: number) =>
    devicesOpenedIndex === index ? setDevicesOpenedIndex(-1) : setDevicesOpenedIndex(index);
  const [subIndex, setSubIndex] = React.useState(-1);
  const setSubOpened = (indx: number) => (subIndex === indx ? setSubIndex(-1) : setSubIndex(indx));
  const hamburgerClass = devicesOpenedMenu ? 'hamburger-container close' : 'hamburger-container';

  function toggleMobileMenu() {
    setDevicesOpenedMenu(!devicesOpenedMenu);
    setDevicesOpenedIndex(-1);
    setSubIndex(-1);
  }

  if (typeof window !== 'undefined') {
    window.onresize = function () {
      if (window.innerWidth > 1023 && devicesOpenedMenu) {
        toggleMobileMenu();
      }
    };
  }

  useEffect(() => {
    if (!devicesOpenedMenu) {
      document.body.classList.remove('no-scroll');
    } else {
      document.body.classList.add('no-scroll');
    }
  }, [devicesOpenedMenu]);

  return (
    <div className={`main-navigation-device-view ${headerDesktopMenuClass}`}>
      <div className={hamburgerClass} onClick={() => toggleMobileMenu()}>
        <div className="hamburger">
          <span className="hamburger-stripe" />
        </div>
      </div>
      <div className={devicesOpenedMenu ? 'main-navigation-devices devices-opened' : 'main-navigation-devices'}>
        <LinkLogo linkClass="link-logo" />
        <div className="main-navigation-devices-inner">
          <div className="main-navigation-devices-menu">
            {Array.from(menu)
              .slice(0, menu.length - 1)
              .map((key: any) => {
                return (
                  <div key={nanoid()} className="main-navigation-item">
                    <LinkTo to={key.Link} pageContext={pageContext} className="link">
                      {key.Text}
                    </LinkTo>
                  </div>
                );
              })}
          </div>
          {/* {pageContext.localeObjects.length > 1 && (
            <LanguageSelector
              className="main-navigation-item navigation-language mobile-language-select"
              pageContext={pageContext}
            />
          )} */}
        </div>
        <div className="main-navigation-devices-footer">
          <ContactUs buttonData={menu[menu.length - 1]} pageContext={pageContext} />
        </div>
      </div>
    </div>
  );
};

export default DeviceMenu;
